// !function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var n="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),i=[],d=!1,l=-1,c=void 0,s=void 0,u=void 0,a=function(o){return i.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})},v=function(e){var o=e||window.event;return!!a(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))},r=function(){void 0!==u&&(document.body.style.paddingRight=u,u=void 0),void 0!==c&&(document.body.style.overflow=c,c=void 0)},f=function(){if(void 0!==s){var e=-parseInt(document.body.style.top,10),o=-parseInt(document.body.style.left,10);document.body.style.position=s.position,document.body.style.top=s.top,document.body.style.left=s.left,window.scrollTo(o,e),s=void 0}};exports.disableBodyScroll=function(r,e){if(r){if(!i.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};i=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(i),[o]),n?window.requestAnimationFrame(function(){if(void 0===s){s={position:document.body.style.position,top:document.body.style.top,left:document.body.style.left};var e=window,o=e.scrollY,t=e.scrollX,n=e.innerHeight;document.body.style.position="fixed",document.body.style.top=-o,document.body.style.left=-t,setTimeout(function(){return window.requestAnimationFrame(function(){var e=n-window.innerHeight;e&&n<=o&&(document.body.style.top=-(o+e))})},300)}}):function(e){if(void 0===u){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;if(o&&0<t){var n=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"),10);u=document.body.style.paddingRight,document.body.style.paddingRight=n+t+"px"}}void 0===c&&(c=document.body.style.overflow,document.body.style.overflow="hidden")}(e),n&&(r.ontouchstart=function(e){1===e.targetTouches.length&&(l=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-l,!a(o.target)&&(t&&0===t.scrollTop&&0<i?v(o):(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?v(o):o.stopPropagation()))},d||(document.addEventListener("touchmove",v,t?{passive:!1}:void 0),d=!0))}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){n&&(i.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),d&&(document.removeEventListener("touchmove",v,t?{passive:!1}:void 0),d=!1),l=-1),n?f():r(),i=[]},exports.enableBodyScroll=function(o){o?(i=i.filter(function(e){return e.targetElement!==o}),n&&(o.ontouchstart=null,o.ontouchmove=null,d&&0===i.length&&(document.removeEventListener("touchmove",v,t?{passive:!1}:void 0),d=!1)),n?f():r()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

/*
////////////////////////////////////////////////////////////////////////////////
--------------------------------------------------------------------------------
SDG Custom Functions

    XX. Run DOM Ready
    XX. Run Global Functions

////////////////////////////////////////////////////////////////////////////////
--------------------------------------------------------------------------------
*/
(function ($) {
  $.sdg = {};
  /*
	----------------------------------------------------------------------------
	XX. Run DOM Ready
	----------------------------------------------------------------------------
	*/
  $.sdg.runDomReady = function () {
    $.sdg.header();
    //$.sdg.footer();
    $.sdg.family();
    $.sdg.friends();

    if (themeSettings.enable_flash_sale) {
      $.sdg.flashsale({
        settings: themeSettings,
      });
    }

    searchbox = new $.sdg.searchbox();

    KlaviyoSubscribe.attachToForms("#email_signup", {
      hide_form_on_success: true,
      success_message: "Thank you for subscribing!",
      extra_properties: {
        $source: "website-footer",
      },
    });

    KlaviyoSubscribe.attachToForms("#women_signup", {
      hide_form_on_success: true,
      success_message: "Thank you for subscribing, get ready to stand out!",
      extra_properties: {
        $source: "womens-landing",
      },
    });

    $.sdg.criteo();
  };

  /*
	----------------------------------------------------------------------------
	XX. Run Functions that do not block page load
	----------------------------------------------------------------------------
	*/
  $.sdg.run = function () {
    var bag = new $.sdg.bag(),
      menus = new $.sdg.menus();

    $.sdg.placeholder(".input-placeholder input");
    $.sdg.placeholder(".input-placeholder textarea");
  };

  /*
	----------------------------------------------------------------------------
	04. Debounce
	----------------------------------------------------------------------------
	*/
  $.sdg.debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced() {
      var obj = this,
        args = arguments;

      function delayed() {
        if (!execAsap) func.apply(obj, args);
        timeout = null;
      }

      if (timeout) clearTimeout(timeout);
      else if (execAsap) func.apply(obj, args);

      timeout = setTimeout(delayed, threshold || 100);
    };
  };

  /*
	----------------------------------------------------------------------------
	05. Media Query
	----------------------------------------------------------------------------
	*/
  $.sdg.mq = function (opts) {
    var config = {
        view: null,
        callback: null,
        views: {
          small_phone: "(max-width:640px)",
          phone: "(max-width:767px)",
          mobile: "(max-width:1024px)",
          phone_to_desktop: "(min-width:563px)",
          tablet: "(min-width:768px)",
          tablet_only: "(min-width:768px) and (max-width:1024px)",
          tablet_portrait: "(min-width:768px) and (max-width:979px)",
          tablet_landscape: "(min-width:980px) and (max-width:1024px)",
          desktop: "(min-width:1025px)",
          desktop_to_large: "(min-width:1025px) and (max-width:1280px)",
          desktop_large: "(min-width:1281px)",
          desktop_large_to_huge: "(min-width:1281px) and (max-width:1400px)",
          desktop_huge: "(min-width:1401px)",
        },
      },
      c = $.extend(config, opts),
      mq = {
        init: function () {
          if (c.view) {
            var currentView = null;

            $.each(c.views, function (key, value) {
              if (key === c.view) {
                currentView = value;
              }
            });

            var query = Modernizr.mq(currentView);

            if (query) {
              c.callback();
            }
          }
        },
      };

    return mq.init();
  };

  /*
	----------------------------------------------------------------------------
	06. Placeholder
	----------------------------------------------------------------------------
	*/
  $.sdg.placeholder = function (target) {
    init = function () {
      valueHasChanged();

      $(target).each(function () {
        checkValue($(this));
      });
    };

    valueHasChanged = function () {
      $("body").on("change keyup", target, function () {
        checkValue($(this));
      });
    };

    checkValue = function (field) {
      if ($(field).val() !== "") {
        $(field).parent(".input-placeholder").addClass("has-value");
      } else {
        $(field).parent(".input-placeholder").removeClass("has-value");
      }
    };

    init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Search
	----------------------------------------------------------------------------
	*/
  $.sdg.searchbox = function (opts) {
    var config = {
        submitIcon: ".searchbox__icon",
        inputBox: ".searchbox__input",
        submitBtn: ".searchbox__submit",
        searchBox: ".searchbox",
        searchBoxOpen: "searchbox__open",
        open: "open",
        container: ".header__search",
        isOpen: false,
      },
      d = $.extend({}, config, opts),
      searchbox = {
        init: function () {
          // searchbox.doIt();
          // searchbox.closeOutsideClick();
        },

        buttonUp: function () {
          var inputVal = $(d.inputBox).val();
          inputVal = jQuery.trim(inputVal).length;

          if (inputVal !== 0) {
            $(d.submitIcon).css("display", "none");
            $(d.submitBtn).css("display", "block");
          } else {
            //$(d.inputBox).val('');
            $(d.submitIcon).css("display", "block");
          }
        },

        closeSearch: function () {
          $(d.searchBox).removeClass(d.searchBoxOpen);
          $(d.container).removeClass(d.open);
          $(d.inputBox).focusout();
          $(d.inputBox).val("");
          d.isOpen = false;
          searchbox.buttonUp();
        },

        openSearch: function () {
          $(d.searchBox).addClass(d.searchBoxOpen);
          $(d.container).addClass(d.open);
          $(d.inputBox).focus();
          d.isOpen = true;
        },

        doIt: function () {
          $(d.inputBox).keyup(function () {
            searchbox.buttonUp();
          });

          $(d.submitIcon).on("click", function () {
            if (d.isOpen === false) {
              searchbox.openSearch();
            } else {
              searchbox.closeSearch();
            }
          });
        },

        closeOutsideClick: function () {
          $(document).on("mouseup", function (e) {
            if (
              !$(d.container).is(e.target) &&
              $(d.container).has(e.target).length === 0
            ) {
              searchbox.closeSearch();
            }
          });
        },
      };

    return searchbox.init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Accordion
	Notes:
	parentTrigger = the click object
	childContainer = the container you want to have slide open
	If you want a menu item open by default, add "open" to the child container.
	----------------------------------------------------------------------------
	*/
  $.sdg.accordion = function (opts) {
    var config = {
        id: "#accordion",
        trigger: ".accordion__trigger",
        menu: ".accordion__content",
        scroll_scope: "html,body",
        scroll_offset: 60,
        active: "active",
        menu_open: "open",
        timer: 350,
        type: "accordion",
        open_callback: null,
        responsive: null,
        active_views: null,
        inactive_views: null,
        current_view: null,
      },
      c = $.extend(config, opts),
      accordion = {
        init: function () {
          if (c.responsive) {
            accordion.responsive();
            accordion.windowResize();
          } else {
            accordion.bindToggle();
          }
        },

        bindToggle: function () {
          $(c.id).on("click", c.trigger, function () {
            accordion.state($(this));
          });
        },

        unbindToggle: function () {
          $(c.id).off("click", c.trigger);
          accordion.clearStyles();
        },

        state: function (obj) {
          if (obj.hasClass(c.active)) {
            if (c.type === "accordion") {
              accordion.focusViewport($(c.id));
            }

            accordion.close(obj);
          } else {
            accordion.focusViewport(obj);

            accordion.open(obj);
          }
        },

        open: function (obj) {
          if (c.type === "accordion") {
            accordion.close();
          }

          obj.addClass(c.active);

          obj.next(c.menu).addClass(c.menu_open).slideDown(c.timer);

          if (c.open_callback) {
            c.open_callback();
          }
        },

        close: function (obj) {
          if (obj) {
            obj
              .removeClass(c.active)
              .next(c.menu)
              .removeClass(c.menu_open)
              .slideUp(c.timer);
          } else {
            $(c.id)
              .find("." + c.active)
              .removeClass(c.active)
              .next(c.menu)
              .removeClass(c.menu_open)
              .slideUp(c.timer);
          }
        },

        focusViewport: function (obj, pos) {
          if (c.scroll_scope) {
            setTimeout(function () {
              var offset;
              if (c.scroll_offset) {
                offset =
                  $(c.scroll_scope).scrollTop() +
                  obj.offset().top -
                  c.scroll_offset;
              } else {
                offset = $(c.scroll_scope).scrollTop() + obj.offset().top;
              }

              $(c.scroll_scope).animate(
                {
                  scrollTop: pos === undefined ? offset : pos,
                },
                c.timer,
                "swing"
              );
            }, c.timer);
          }
        },

        windowResize: function () {
          $(window).on(
            "resize",
            $.sdg.debounce(function () {
              accordion.responsive();
            })
          );
        },

        responsive: function () {
          var active_views = c.active_views,
            inactive_views = c.inactive_views;

          $.each(active_views, function (index, value) {
            var view = value;

            if (c.current_view !== view) {
              $.sdg.mq({
                view: view,
                callback: function () {
                  c.current_view = view;
                  accordion.bindToggle();
                },
              });
            }
          });

          $.each(inactive_views, function (index, value) {
            var view = value;

            if (c.current_view !== view) {
              $.sdg.mq({
                view: view,
                callback: function () {
                  c.current_view = view;
                  accordion.unbindToggle();
                },
              });
            }
          });
        },

        clearStyles: function () {
          $(c.id)
            .find(c.trigger)
            .removeClass(c.active)
            .next(c.menu)
            .removeClass(c.menu_open)
            .removeAttr("style");
        },
      };

    return {
      init: accordion.init(),
      open: accordion.open,
      close: accordion.close,
    };
  };

  /*
	----------------------------------------------------------------------------
	XX. Modals
	----------------------------------------------------------------------------
	*/
  $.sdg.modal = function (opts) {
    var config = {
        obj: ".modal",
        trigger: ".modal__trigger",
        close: ".modal__close",
        visible: "modal--visible",
        overlay: ".modal__overlay",
        overlay_visible: ".modal__overlay--visible",
        overflow: "overflow--hidden",
        timer: 250,
        closeCallback: null,
        openCallback: null,
        autoshow: false,
        autoshow_delay: 250,
      },
      c = $.extend(config, opts),
      modal = {
        init: function () {
          modal.triggerOpen();
          modal.triggerClose();
          modal.keyboard();

          if (c.autoshow === true) {
            setTimeout(function () {
              modal.open(c.obj);
            }, c.autoshow_delay);
          }
        },

        triggerOpen: function () {
          $("body").on("click", c.trigger, function (e) {
            e.preventDefault();

            $(c.trigger).removeClass("trigger-active");
            $(this).addClass("trigger-active");

            var modalToOpen = $(this).data("modal-open");

            modal.open(modalToOpen);
          });
        },

        open: function (el) {
          if (el.match("^#")) {
            el = el.replace("#", "");
          }

          var modalClass = el + "-open";

          $("body").addClass(c.overflow + " " + modalClass);

          $("#" + el)
            .addClass(c.visible)
            .next(c.overlay)
            .addClass(c.visible + " modal__" + el);

          setTimeout(function () {
            if (c.openCallback) {
              c.openCallback();
            }
          }, c.timer);
        },

        close: function (el) {
          var modalClass;

          if (typeof el === "object") {
            modalClass = el.attr("id") + "-open";
          } else {
            modalClass = el + "-open";
          }

          $(el).removeClass(c.visible).next(c.overlay).removeClass(c.visible);

          setTimeout(function () {
            if (window.location.hash) window.location.hash = "";
            $("body").removeClass(c.overflow).removeClass(modalClass);

            if (c.closeCallback) {
              c.closeCallback();
            }
          }, c.timer);
        },

        triggerClose: function () {
          $("body").on("click", c.close, function (e) {
            e.preventDefault();
            modal.close($("." + c.visible));
          });
        },

        keyboard: function () {
          $(document).keyup(function (e) {
            if (e.keyCode == 27) {
              modal.close($("." + c.visible));
            }
          });
        },
      };

    return {
      init: modal.init(),
      open: modal.open,
      close: modal.close,
    };
  };

  /*
	----------------------------------------------------------------------------
	15. Incrementer
	----------------------------------------------------------------------------
	*/
  $.sdg.incrementer = function (opts) {
    var config = {
        btn: ".increment__btn",
        delay: 500,
        delayed_action: null,
        inc: ".increment",
        inc_input: ".increment__input",
        id: "#bag",
        item: ".bag-item",
        inc_callback: null,
      },
      c = $.extend(config, opts),
      init = function () {
        incrementTrigger();
      },
      incrementTrigger = function () {
        $(c.id).on("click", c.btn, function () {
          var item = {};
          item.action = $(this).data("action");
          item.inc = $(this).parents(c.inc);
          item.obj = item.inc.parents(c.item);
          item.field = item.inc.find(c.inc_input);
          item.current_qty = item.field.val();
          item.variant_id = item.obj.data("variant-id");

          increment(item);
        });
      },
      increment = function (item) {
        clearTimeout(c.delayed_action);

        var newQty,
          currQty = parseInt(item.current_qty);

        if (item.action === "add") {
          newQty = currQty + 1;
        } else {
          if (currQty > 1) {
            newQty = currQty - 1;
          } else {
            newQty = 1;
          }
        }

        item.field.val(newQty);

        if (c.inc_callback) {
          c.delayed_action = setTimeout(function () {
            c.inc_callback(item, newQty);
          }, c.delay);
        }
      };

    return {
      init: init(),
    };
  };

  /*
	----------------------------------------------------------------------------
	07. Lazy Load
	----------------------------------------------------------------------------
	*/
  $.sdg.lazyLoad = function (opts) {
    var config = {
        id: null,
        single_selector: "img.lazy",
        responsive: false,
        responsive_selectors: [
          "phone",
          "mobile",
          "tablet",
          "tablet_only",
          "desktop",
        ],
        threshhold: 300,
        responsive_refresh: 500,
        loaded: "loaded",
        loading: "loading",
        loadCallBack: null,
        triggerOnLoad: false,
      },
      c = $.extend(config, opts),
      unveiled = [],
      lazyLoad = {
        init: function () {
          if (c.responsive === true) {
            lazyLoad.runUnveil(c.single_selector);
            lazyLoad.responsiveInit();
            lazyLoad.responsiveResize();
          } else {
            lazyLoad.runUnveil(c.single_selector);
            if (c.triggerOnLoad === true) {
              lazyLoad.triggerOnLoad(c.single_selector);
            }
          }
        },
        responsiveInit: function () {
          var sizes = c.responsive_selectors,
            sizesArr = $.makeArray(sizes);

          $.each(sizes, function (index, value) {
            var size = value;

            $.sdg.mq({
              view: size,
              callback: function () {
                if ($.inArray(size, unveiled) === -1) {
                  sizeClass = size;

                  if (size == "tablet_only") {
                    sizeClass = "tablet";
                  }

                  if (size == "tablet") {
                    sizeClass = "desktop-and-tablet";
                  }

                  lazyLoad.runUnveil("." + sizeClass + "-lazy");

                  if (c.triggerOnLoad === true) {
                    lazyLoad.triggerOnLoad("." + sizeClass + "-lazy");
                  }

                  unveiled.push(sizeClass);
                }
              },
            });
          });
        },
        runUnveil: function (obj) {
          var unveilObj = (c.id !== null ? c.id + " " : "") + obj;

          $(unveilObj).unveil(c.threshhold, function () {
            lazyLoad.unveilCallback($(this));
          });
        },
        unveilCallback: function (obj) {
          if (!obj.hasClass(c.loaded)) {
            obj.parent().addClass(c.loading);

            obj.on("load", function () {
              obj
                .css({
                  opacity: 1,
                })
                .addClass(c.loaded);
              obj.addClass(c.loaded).parent().removeClass(c.loading);

              if (c.loadCallBack) {
                c.loadCallBack(obj);
              }
            });
          }
        },
        responsiveResize: function () {
          $(window).on(
            "resize",
            $.sdg.debounce(function () {
              lazyLoad.responsiveInit();
            }, c.responsive_refresh)
          );
        },
        triggerOnLoad: function (obj) {
          $(obj).trigger("unveil");
        },
      };

    return lazyLoad.init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Header
	----------------------------------------------------------------------------
	*/
  $.sdg.header = function () {
    // config
    var c = {
        // classes
        cls: {
          megamenu_exposed: "megamenu-exposed",
        },

        // dom selectors
        dom: {
          megamenu: ".js-megamenu",
        },

        // ids
        id: {
          shop_menu_trigger: "ShopMenuTrigger",
        },
      },
      // states
      state = {
        megamenu_open: false,
      },
      // cached globals
      body = $("body"),
      siteHeader = $(".site-header"),
      menu = $(".burger"),
      $shopMenuTrigger = $("#" + c.id.shop_menu_trigger),
      threshold = 100;

    /**
     * init
     */
    function init() {
      events();
    }

    /**
     * events
     */
    function events() {
      /* collapse the nav when they start scrolling (only on homepage) */
      if (body.hasClass("template-index")) {
        $(window).smartscroll(function () {
          fromTop = $(document).scrollTop();

          if (fromTop > threshold) {
            siteHeader.addClass("header-collapsed");
          } else {
            siteHeader.removeClass("header-collapsed");
          }
        });
      }

      // menu (hamburger) click
      menu.click(function () {
        siteHeader.toggleClass("header-open");
        console.log(siteHeader.hasClass("header-open"));
        if (siteHeader.hasClass("header-open")) {
          // bodyScrollLock.disableBodyScroll(siteHeader);
        } else {
          // bodyScrollLock.enableBodyScroll(siteHeader);
        }
      });

      // shop menu click
      $shopMenuTrigger.click(toggleMegamenu);

      // outside shop menu click
      body.click(outsideMegamenuClick);
    }

    /**
     * toggle shop menu
     * @param {Object} e event
     */
    function toggleMegamenu(e) {
      // prevent default click action
      e.preventDefault();

      // open menu if not already open,
      // else close it
      if (!state.megamenu_open) {
        openMegamenu();
      } else {
        closeMegamenu();
      }
    }

    /**
     * open megamenu
     */
    function openMegamenu() {
      // set state
      state.megamenu_open = true;

      // add exposed class
      body.addClass(c.cls.megamenu_exposed);
    }

    /**
     * close megamenu
     */
    function closeMegamenu() {
      // set state
      state.megamenu_open = false;

      // remove exposed class
      body.removeClass(c.cls.megamenu_exposed);
    }

    /**
     * outside megamenu click
     * @param {Object} e event
     */
    function outsideMegamenuClick(e) {
      var target = e.target,
        $target = $(target),
        isTargetTrigger = target.id === c.id.shop_menu_trigger,
        isTargetWithinMegamenu = $target.closest(c.dom.megamenu).length !== 0;

      // if megamenu isn't open, if target is the trigger,
      // if target is within the megamenu, exit function
      if (!state.megamenu_open || isTargetTrigger || isTargetWithinMegamenu) {
        return;
      }

      // close megamenu
      closeMegamenu();
    }

    init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Footer
	----------------------------------------------------------------------------
	*/
  $.sdg.footer = function () {
    var newsletter = $(".newsletter");
    var myMsg = $(".msg");

    init = function () {
      events();
    };

    function events() {
      /* newsletter signup form */
      $(".form-wear").validate({
        errorClass: "has-error",
        submitHandler: function (form) {
          $("#wear_email").val("");
          $(".form-wear-thanks").fadeIn();

          $.post($(form).attr("action"), $(form).serialize());

          setTimeout(function () {
            $(".form-wear-thanks").fadeOut();
          }, 5000);
        },
      });

      /* wholesale form */
      $(".form-sell").validate({
        errorClass: "has-error",
        submitHandler: function (form) {
          $(form)[0].reset();
          $(".form-sell-thanks").fadeIn();

          $.post($(form).attr("action"), $(form).serialize());
        },
      });
    }

    init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Family
	----------------------------------------------------------------------------
	*/
  $.sdg.family = function () {
    init = function () {
      events();
    };

    function events() {
      /* public selectors */
      var bro = $(".brother");

      /* private selectors */
      var body = $("body");

      bro.click(function () {
        bro = $(this).attr("bro");

        $(".family-overlay." + bro + "-details").toggleClass("hidden");
        body.toggleClass("showing-family");
      });

      $(".overlay-overlay").click(function () {
        $(this).parent(".family-overlay").toggleClass("hidden");
        body.toggleClass("showing-family");
      });
    }

    init();
  };

  /*
	----------------------------------------------------------------------------
	XX. Friends
	----------------------------------------------------------------------------
	*/
  $.sdg.friends = function () {
    init = function () {
      events();
    };

    function events() {
      /* public selectors */
      var friend = $(".friends__item");

      /* private selectors */
      var body = $("body");

      friend.click(function () {
        index = $(this).attr("data-index");

        $('.friends__overlay[data-index="' + index + '"]').toggleClass(
          "hidden"
        );
        body.toggleClass("showing-family");
      });

      $(".friends__overlay-bg").click(function () {
        $(this).parent(".friends__overlay").toggleClass("hidden");
        body.toggleClass("showing-friends");
      });
    }

    init();
  };

  /*
	----------------------------------------------------------------------------
	13. Menus
	----------------------------------------------------------------------------
	*/
  $.sdg.menus = function (opts) {
    var config = {
        nav: {
          id: "#nav",
          toggle: "#navToggle",
          overlay: "#navOverlay",
          close: "#navClose",
          active: "active",
          open: "is-open",
          exposed: "nav--exposed",
          fixed: "nav--fixed",
          header_nav_id: "#headerNav",
          desktop_btns: ".header-nav__item-hover",
          hovered: "header-nav--hovered",
          acc_options: {
            id: "#nav",
            trigger: ".nav__cat",
            menu: ".nav__litter",
            scroll_scope: ".nav__content",
          },
        },

        bag: {
          id: "#bag",
          toggle: "#btnBag",
          overlay: "#bagOverlay",
          close: "#bagClose,#btnKeepShopping",
          active: "active",
          exposed: "bag--exposed",
          fixed: "bag--fixed",
          lazy_loaded: false,
        },
      },
      c = $.extend(config, opts),
      timer = 250,
      open = false,
      menu = {
        init: function () {
          /* Nav */
          for (var key in c) {
            if (!c.hasOwnProperty(key)) continue;

            menu.toggle(key, c[key]);
            menu.closeTrigger(c[key]);

            var prop = c[key];

            if (key == "nav") {
              $.sdg.accordion(c.nav.acc_options);

              menu.navHover(key, c[key]);
            }
          }

          menu.windowResize();
        },

        toggle: function (key, val) {
          $(val.toggle + "," + val.overlay).on("click", function (e) {
            e.preventDefault();

            menu.state($(this));

            if (open === true) {
              $(val.toggle + "," + val.overlay).addClass(val.active);
              if (val.toggle === "#btnBag") {
                if (!document.getElementById("zip-script")) {
                  let zipScript = document.createElement("script");
                  zipScript.id = "zip-script";
                  zipScript.src =
                    "https://cdn.quadpay.com/v1/quadpay.js?tagname=quadpay-widget";
                  document.body.appendChild(zipScript);
                }
              }
              $("body").addClass(val.exposed + " " + val.fixed);
            }

            if (key == "bag") {
              if (val.lazy_loaded === false) {
                $.sdg.lazyLoad({
                  id: val.id,
                });
                val.lazy_loaded = true;
                $("#" + key)
                  .find(".lazy")
                  .trigger("unveil");
              }
            }
          });
        },

        state: function (obj) {
          for (var key in c) {
            var prop = c[key];

            if (
              "#" + obj.attr("id") === prop.toggle ||
              "#" + obj.attr("id") === prop.overlay
            ) {
              if ($(prop.toggle).hasClass(prop.active)) {
                menu.close(prop);

                open = false;
              } else {
                open = true;
              }
            } else {
              if ($(prop.toggle).hasClass(prop.active)) {
                menu.close(prop);
              }
            }
          }
        },

        close: function (key) {
          $(key.toggle + "," + key.overlay).removeClass(key.active);

          $("body").removeClass(key.exposed);

          if (key == nav) {
            $.sdg.accordion.collapseAccordion(key.id);
          }

          setTimeout(function () {
            $("body").removeClass(key.fixed);
          }, timer);
        },

        closeTrigger: function (key) {
          $(key.close).on("click", function () {
            menu.close(key);
          });
        },

        windowResize: function () {
          $(window).on(
            "resize",
            $.sdg.debounce(function () {
              $.sdg.mq({
                view: "desktop",
                callback: function () {
                  if ($("body").hasClass("nav--exposed")) {
                    $("#navClose").trigger("click");
                  }
                },
              });
            })
          );
        },

        navHover: function (key, val) {
          $(val.header_nav_id).on("mouseover", val.desktop_btns, function () {
            $("body").addClass(val.hovered);
            $(this).addClass(val.open);
          });

          $(val.header_nav_id).on("mouseleave", val.desktop_btns, function () {
            $("body").removeClass(val.hovered);
            $(this).removeClass(val.open);
          });
        },
      };

    return menu.init();
  };

  /*
	----------------------------------------------------------------------------
 	Flash Sale
	----------------------------------------------------------------------------
	*/

  $.sdg.flashsale = function (opts) {
    var config = {
        timer: 1000,
        settings: themeSettings,
        saleItem: flashsaleItem,
        container: ".flashsale-wrapper",
        cDays: ".countdown-days",
        cHours: ".countdown-hours",
        cMinutes: ".countdown-minutes",
        cSeconds: ".countdown-seconds",
        message: ".name",
        countdown: ".countdowns-wrapper",
      },
      c = $.extend(config, opts),
      counter = function (name, url, saleTimestamp, nowTimestamp) {
        this.saleName = name;
        this.productUrl = url;
        this.saleTimestamp = saleTimestamp;
        this.startTimestamp = nowTimestamp;
        this.now = nowTimestamp;
        this.daysUntil = 0;
        this.minutesUntil = 0;
        this.secondsUntil = 0;
        this.interval = null;

        this.startTimer = function () {
          if (this.interval) {
            return;
          }
          var parent = this;
          this.interval = window.setInterval(function () {
            parent.now++;
            parent.setDaysHoursMinutesSeconds();
          }, 1000);
        };

        this.setDaysHoursMinutesSeconds = function () {
          var secondsBetweenTimestamps = this.saleTimestamp - this.now;
          this.daysUntil = Math.floor(secondsBetweenTimestamps / 60 / 60 / 24);
          var remainder =
            secondsBetweenTimestamps - this.daysUntil * 60 * 60 * 24;
          this.hoursUntil = Math.floor(remainder / 60 / 60);
          remainder -= this.hoursUntil * 60 * 60;
          this.minutesUntil = Math.floor(remainder / 60);
          remainder -= this.minutesUntil * 60;
          this.secondsUntil = Math.floor(remainder);
        };

        this.padZero = function (number) {
          return number < 10 ? "0" + number : number;
        };
      },
      flashsale = {
        init: function () {
          // Check if Daylight Saving time
          var dst = 0;
          if (c.settings.flash_sale_dst) {
            dst = 1;
          }

          // Set the sale time
          var settingTime = new Date(
            c.settings.flash_sale_item_1_time_year,
            c.settings.flash_sale_item_1_time_month - 1,
            c.settings.flash_sale_item_1_time_day,
            c.settings.flash_sale_item_1_time_hour - dst,
            c.settings.flash_sale_item_1_time_mins,
            0,
            0
          );

          settingTime.setTime(settingTime.getTime() + 6 * 60 * 60 * 1000);

          var nowInUTC =
            new Date().getTime() +
            (new Date().getTimezoneOffset() / 60) * 60 * 60 * 1000;

          var url = "/collections/" + c.saleItem.handle;
          if (c.settings.flash_sale_item_1_type == "1") {
            url = "/products/" + c.saleItem.handle;
          }

          // If there is custom sale message
          if (c.settings.flash_sale_title) {
            c.saleItem.title = c.settings.flash_sale_title;
          }

          var sale = new counter(
            c.saleItem.title,
            url,
            settingTime.getTime() / 1000,
            nowInUTC / 1000
          );

          var day = c.settings.flash_sale_item_1_time_day;
          var monthNames = [
            "Jan",
            "Feb",
            "March",
            "April",
            "May",
            "June",
            "July",
            "Aug",
            "Sept",
            "Oct",
            "Nov",
            "Dec",
          ];
          var suffix = [
            "th",
            "st",
            "nd",
            "rd",
            "th",
            "th",
            "th",
            "th",
            "th",
            "th",
          ];

          if (day % 100 >= 11 && day % 100 <= 13) {
            suffixDay = day + "th";
          } else {
            suffixDay = day + suffix[day % 10];
          }

          var launchDate =
            monthNames[c.settings.flash_sale_item_1_time_month - 1] +
            " " +
            suffixDay;

          this.run(sale);
        },

        run: function (sale) {
          var timerStart = Date.now();

          if (c.settings.enable_flashsale_item_1) {
            $(c.container).on("click", function () {
              window.location = sale.productUrl;
            });
            $(c.container).addClass("is-link");
          }

          // if ($(c.container).length && typeof sale != "undefined") {
          // 	$daysElem = $(c.container+' '+c.cDays);
          // 	$hoursElem = $(c.container+' '+c.cHours);
          // 	$minutesElem = $(c.container+' '+c.cMinutes);
          // 	$secondsElem = $(c.container+' '+c.cSeconds);
          // 	$(c.container+' '+c.message).html(sale.saleName);

          // 	if (sale.now < sale.saleTimestamp) {
          // 		$(c.container+' '+c.message).append(' <span class="launches">Launches In</span>');
          // 	}

          // 	sale.now += (Date.now() - timerStart)/1000;
          // 	sale.startTimer();
          // 	window.saleInterval = window.setInterval( function() {
          // 		if (sale.now >= sale.saleTimestamp) {
          // 			window.clearInterval(window.saleInterval);
          // 			if (c.settings.enable_flashsale_item_1 ) {
          // 				$(c.countdown).html("Available now!");
          // 			} else {
          // 				$(c.countdown).hide();
          // 			}

          // 		}
          // 		$daysElem.html(sale.padZero(sale.daysUntil));
          // 		$hoursElem.html(sale.padZero(sale.hoursUntil));
          // 		$minutesElem.html(sale.padZero(sale.minutesUntil));
          // 		$secondsElem.html(sale.padZero(sale.secondsUntil));
          // 	}, c.timer);
          // }

          let flashSaleWrapper = document.querySelector(
            ".flashsale-wrapper > span"
          );
          let messages = document.querySelectorAll("#headerFlashsale .name");
          if (messages.length > 1) {
            let activeIndex = 0;
            let total = messages.length - 1;
            messages[activeIndex].classList.add("isActive");
            setInterval(() => {
              messages[activeIndex].classList.remove("isActive");
              activeIndex = activeIndex + 1;
              if (activeIndex > total) {
                activeIndex = 0;
              }
              messages[activeIndex].classList.add("isActive");
            }, 5000);

            let maxHeight = 0;
            Array.from(messages).map((message) => {
              let height = message.offsetHeight;
              if (height > maxHeight) {
                maxHeight = height;
              }
            });

            flashSaleWrapper.style.height = maxHeight + "px";

            return;
          }

          if (c.settings.enable_flash_sale) {
            setTimeout(function () {
              $(c.container + " " + c.message).addClass("isActive");
              // $(c.container+' '+c.countdown).addClass('isActive');
            }, c.timer);
          } else {
            $(c.container).hide();
          }
        },
      };
    return flashsale.init();
  };

  /*
	----------------------------------------------------------------------------
	16. Bag
	----------------------------------------------------------------------------
	*/

  $.sdg.bag = function (opts) {
    var config = {
        ani_timer: 350,
        btn: ".increment__btn",
        cart_count: ".utility__bag-count",
        empty: "bag--empty",
        hide_if_empty: ".js-hide-if-empty",
        id: "#bag",
        item: ".bag-item",
        list: "#bagItems",
        loading: "loading",
        remove_btn: ".js-bag-item-remove",
        totals: "#bagTotals",
        subtotal: "#bagSubtotal",
        inc_input: ".increment__input",
        no_qty: "bag-item__no-qty",
        bag_actions: ".bag-item__actions",
      },
      c = $.extend(config, opts),
      init = function () {
        $.sdg.incrementer({
          inc_callback: updateItemQty,
        });
        removeTrigger();
      },
      updateItemQty = function (item, newQty) {
        item.obj.addClass(c.loading);

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: {
            quantity: newQty,
            id: item.variant_id,
          },
          success: function (data) {
            var currItems = data.items;

            console.log(item.variant_id);

            for (var k in currItems) {
              if (currItems.hasOwnProperty(k)) {
                var itemC = currItems[k];

                var currItemInCart = true,
                  currItem = itemC.id,
                  currentItemQty = parseInt(itemC.quantity);

                if (itemC.id === item.variant_id) {
                  if (newQty > currentItemQty) {
                    $("#item" + currItem)
                      .find(c.inc_input)
                      .val(currentItemQty);
                    $("#item" + currItem)
                      .find("." + c.no_qty)
                      .remove();
                    $("#item" + currItem)
                      .find(c.bag_actions)
                      .append(
                        '<div class="' +
                          c.no_qty +
                          '">No more available quantities.</div>'
                      );
                  } else {
                    $("#item" + currItem)
                      .find("." + c.no_qty)
                      .remove();
                  }
                }
              }
            }

            $(c.cart_count).html(data.item_count);

            function getCartCount(callback) {
              var fullname;
              $.getJSON("/cart.js", function (cart) {
                callback(cart);
                const addToCartEvent = new CustomEvent("addToCartEvent", {
                  detail: cart,
                });
                document.dispatchEvent(addToCartEvent);
              });
            }

            getCartCount(function (cart) {
              if (cart.item_count === 0) {
                $(c.cart_count).hide();
              } else {
                $(c.cart_count).show();
              }
            });

            if (newQty === 0) {
              item.obj.slideUp(c.ani_timer, function () {
                $(this).remove();
              });
            } else {
              item.obj.removeClass(c.loading);
            }

            if (data.item_count === 0) {
              resetCart();
            } else {
              var recalc = {
                sel: $(c.subtotal),
                price: data.total_price,
              };
              $.sdg.bag.recalcSubTotal(recalc);
            }
          },
        });
      },
      removeTrigger = function () {
        $(c.id).on("click", c.remove_btn, function (e) {
          e.preventDefault();

          var item = {};
          item.obj = $(this).parents(c.item);
          item.variant_id = item.obj.data("variant-id");

          updateItemQty(item, 0);
        });
      },
      resetCart = function () {
        $(c.id).addClass(c.empty);
      };

    return {
      init: init(),
    };
  };

  $.sdg.bag.recalcSubTotal = function () {
    var sub = $("#bagSubtotal");

    $.getJSON("/cart.js", function (cart, textStatus) {
      var nt = (cart.total_price / 100).toFixed(2);
      nt = "$" + nt.replace(/\.00$/, "");
      $(sub).html(nt);
    });
  };

  $.sdg.bag.refresh = function (opts) {
    var config = {
        bag: "#bag",
        empty: "bag--empty",
        list: "#bagItems",
        item: ".bag-item",
        itemTemplate: function (obj) {
          var img = obj.image,
            img_standard = img.replace(".jpg", "_compact.jpg"),
            img_retina = img.replace(".jpg", "_medium.jpg"),
            original_price = (obj.original_price / 100).toFixed(2),
            sale_price = obj.total_discount,
            variants = obj.variant_options;

          if (sale_price !== 0) {
            sale_price = ((obj.original_price - sale_price) / 100).toFixed(2);
            sale_price = "$" + sale_price.replace(/\.00$/, "");
          }

          original_price = "$" + original_price.replace(/\.00$/, "");

          let extraClass = "";
          if (obj.total_discount > 0) {
            extraClass = "bag-item--on-sale";
          }

          let promoMessage = "";
          obj.line_level_discount_allocations.map((discount) => {
            // if (discount.discountApplication.title) {
            promoMessage =
              '<p class="discount-message">' +
              discount.discount_application["title"] +
              "</p>";
            // }
          });

          var item =
            '<article class="bag-item ' +
            extraClass +
            '" id="item' +
            obj.variant_id +
            '" data-variant-id="' +
            obj.variant_id +
            '">' +
            '<div class="cf">' +
            '<figure class="bag-item__photo">' +
            '<div class="p-photo-ir">' +
            '<img data-src="' +
            img_standard +
            '" data-src-retina="' +
            img_retina +
            '" class="lazy" alt="{{ item.title | escape }}" />' +
            "</div>" +
            "</figure>" +
            '<div class="bag-item__desc">' +
            '<header class="bag-item__header">' +
            '<h4 class="bag-item__title">' +
            '<a href="' +
            obj.product_url +
            '">' +
            obj.product_title +
            "</a>" +
            "</h4>" +
            "</header>" +
            '<p class="bag-item__price">' +
            '<span class="bag-item__original-price">' +
            original_price +
            "</span>" +
            (sale_price !== 0
              ? '<span class="bag-item__sale-price">' + sale_price + "</span>"
              : "") +
            "</p>" +
            '<ul class="list--reset cart__variants bag-item__variants">' +
            (variants[0] && variants[0] != "Default Title"
              ? '<li><span class="cart__variants-spacer">&ndash;</span>' +
                variants[0] +
                "</li>"
              : "") +
            (variants[1] && variants[1] != "Default Title"
              ? '<li><span class="cart__variants-spacer">&ndash;</span>' +
                variants[1] +
                "</li>"
              : "") +
            (variants[2] && variants[2] != "Default Title"
              ? '<li><span class="cart__variants-spacer">&ndash;</span>' +
                variants[2] +
                "</li>"
              : "") +
            "</ul>" +
            promoMessage +
            '<div class="bag-item__actions">' +
            '<div class="bag-item__qty increment">' +
            '<input min="1" type="number" name="quantity" value="' +
            obj.quantity +
            '" size="3" class="increment__input" />' +
            '<button type="button" class="increment__btn increment__add" data-action="add"><span>Add</span></button>' +
            '<button type="button" class="increment__btn increment__subtr" data-action="subtract"><span>Subtract</span></button>' +
            "</div>" +
            '<a href="/cart/change/' +
            obj.variant_id +
            '?quantity=0" title="Remove item" class="bag-item__remove btn-remove js-bag-item-remove" role="button" data-variant-id="' +
            obj.variant_id +
            '"><i class="btn-remove__icon icons icons--remove-white"></i><span class="screenreader">Remove</span></a>' +
            "</div>" +
            "</div>" +
            "</div>" +
            "</article>";
          return item;
        },
      },
      c = $.extend(config, opts),
      init = function () {
        $.getJSON("/cart.js", function (cart, textStatus) {
          var items = cart.items,
            html = [];

          for (var i in items) {
            var item = c.itemTemplate(items[i]);
            html.push(item);
          }

          $(c.list).find(c.item).remove();
          $(c.list).prepend(html);
          $.sdg.lazyLoad({
            id: c.list,
          });
          $(c.list).find(".lazy").trigger("unveil");

          $.sdg.bag.recalcSubTotal();

          if ($(c.bag).hasClass(c.empty)) {
            $(c.bag).removeClass(c.empty);
          }
        });
      };

    return init();
  };

  /*
	----------------------------------------------------------------------------
 	Criteo
	----------------------------------------------------------------------------
	*/

  $.sdg.criteo = function () {
    $(document).ajaxSuccess(function (event, xhr, settings) {
      var basketdata = [];

      if (settings) {
        if (
          settings.url == "/cart/add.js" ||
          settings.url == "/cart/update.js"
        ) {
          $.getJSON("/cart.js", function (data) {
            basketdata = data.items.map(function (item) {
              return {
                id: item.product_id,
                price: item.price / 100,
                quantity: item.quantity,
              };
            });
            window.criteo_q.push({ event: "viewBasket", product: basketdata });
          });
        }
      }
    });
  };

  /*
	----------------------------------------------------------------------------
	trigger event
	----------------------------------------------------------------------------
	*/
  $.sdg.trigger = function (el, eventName) {
    console.log(el, eventName);
    if (el === undefined || eventName === undefined) return false;

    var event = new CustomEvent(eventName, {
      detail: {
        el: el,
        time: new Date(),
        obj: null,
      },
      bubbles: false,
      cancelable: false,
    });

    el.dispatchEvent(event);

    return undefined;
  };
})(jQuery);

/*
----------------------------------------------------------------------------
17. Run Global Functions
----------------------------------------------------------------------------
*/
$.sdg.run();

jQuery("document").ready(function ($) {
  $.sdg.runDomReady();
});

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

(function ($) {
  $.fn.unveil = function (threshold, callback) {
    var $w = $(window),
      th = threshold || 0,
      retina = window.devicePixelRatio > 1,
      attrib = retina ? "data-src-retina" : "data-src",
      images = this,
      loaded;

    this.one("unveil", function () {
      var source = this.getAttribute(attrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        this.setAttribute("src", source);
        if (typeof callback === "function") callback.call(this);
      }
    });

    function unveil() {
      var inview = images.filter(function () {
        var $e = $(this);
        if ($e.is(":hidden")) return;

        var wt = $w.scrollTop(),
          wb = wt + $w.height(),
          et = $e.offset().top,
          eb = et + $e.height();

        return eb >= wt - th && et <= wb + th;
      });

      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

    unveil();

    return this;
  };
})(window.jQuery || window.Zepto);

(function ($, sr) {
  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced() {
      var obj = this,
        args = arguments;
      function delayed() {
        if (!execAsap) func.apply(obj, args);
        timeout = null;
      }

      if (timeout) clearTimeout(timeout);
      else if (execAsap) func.apply(obj, args);

      timeout = setTimeout(delayed, threshold || 20);
    };
  };
  // smartresize
  jQuery.fn[sr] = function (fn) {
    return fn ? this.bind("scroll", debounce(fn)) : this.trigger(sr);
  };
})(jQuery, "smartscroll");

if (page_handle in path) {
  console.log("file to load", path[page_handle]);
  // require([path[page_handle]]);
  var script = document.createElement("script");
  script.src = path[page_handle];
  document.write(script.outerHTML);
}
